import PropTypes from 'prop-types';
import React from 'react';

export const CandleBreakWrapper = ({ softOrder, Component, ...rest }) => {
  const candleDuration = softOrder.candleDuration;
  const breakBy = softOrder.breakBy;
  const priceToBreakLong = softOrder['priceToBreak (long)'];
  const priceToBreakShort = softOrder['priceToBreak (short)'];
  const priceToBreak = softOrder.priceToBreak;
  const quantityBasisValue = softOrder.quantityBasisValue;
  const details = {
    tacticName: 'CANDLE_BREAK',
    category: 'Entry',
    type: 'Candle Break',
    domain: 'Underlying',
  };
  
  return (
    <Component
      candleDuration={candleDuration}
      breakBy={breakBy}
      priceToBreakLong={priceToBreakLong}
      priceToBreakShort={priceToBreakShort}
      priceToBreak={priceToBreak}
      quantityBasisValue={quantityBasisValue}
      details={details}
      {...rest}
    />
  );
};

CandleBreakWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    breakBy: PropTypes.any,
    candleDuration: PropTypes.any,
    priceToBreak: PropTypes.any,
    quantityBasisValue: PropTypes.any
  })
};



